<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>机器人配置</span>
        </div>

        <el-form class="demo-form-inline">
          <el-form-item label="申请好友">
            <el-card class="box-card">
              <el-form-item label="添加好友延迟(秒)">
                <el-input v-model.number="formData.newUserMin" style="width: 100px;" placeholder="最小值" />
                <span style="margin-left:5px;margin-right:5px">-</span>
                <el-input v-model.number="formData.newUserMax" style="width: 100px;" placeholder="最大值" />
              </el-form-item>
              <el-form-item label="升级延时(秒)" style="margin-top: 5px">
                <el-input v-model.number="formData.upgradeMin" style="width: 100px;" placeholder="最小值" />
                <span style="margin: 0px 5px">-</span>
                <el-input v-model.number="formData.upgradeMax" style="width: 100px;" placeholder="最大值" />
              </el-form-item>
              <el-form-item label="添加好友数量(秒)" style="margin-top: 5px">
                <el-input v-model.number="formData.maxAddFriendCount" style="width: 100px;" placeholder="添加好友数量" />
              </el-form-item>
            </el-card>
          </el-form-item>
          <el-form-item label="打">
            <el-card class="box-card">
              <el-form-item label="恢复体力时间">
                <el-time-select
                  v-model="formData.addSpin"
                  :picker-options="{
                    start: '00:00',
                    step: '00:15',
                    end: '23:23'
                  }"
                  placeholder="恢复体力时间"
                />
              </el-form-item>
              <el-form-item label="体力上限" style="margin-top: 10px">
                <el-card class="box-card">
                  <el-form :inline="true">
                    <el-row v-for="(item, index) in formData.spins" :key="index" style="margin-top: 5px">
                      <el-form-item label="等级范围">
                        <el-input v-model.number="item.min" style="width: 100px;" placeholder="最小值" />
                      </el-form-item>
                      <el-form-item label="-">
                        <el-input v-model.number="item.max" style="width: 100px;" placeholder="最大值" />
                      </el-form-item>
                      <el-form-item label="体力上限">
                        <el-input v-model.number="item.spin" style="width: 100px;" placeholder="体力上限" />
                      </el-form-item>
                      <el-form-item label="倍率">
                        <el-input v-model.number="item.bet" style="width: 100px;" placeholder="倍率" />
                      </el-form-item>
                      <el-form-item>
                        <el-button type="danger" @click="delSpin(index)">删除</el-button>
                      </el-form-item>
                    </el-row>
                    <el-button type="primary" @click="addSpin()">+</el-button>
                  </el-form>
                </el-card>
              </el-form-item>
            </el-card>
          </el-form-item>
          <el-form-item label="礼物互赠">
            <el-form-item label="赠送时间范围">
              <el-time-select
                v-model="formData.giftStart"
                :picker-options="{
                  start: '00:00',
                  step: '00:15',
                  end: '23:23'
                }"
                placeholder="开始时间"
              />
              <span style="margin-left:5px;margin-right:5px">-</span>
              <el-time-select
                v-model="formData.giftEnd"
                :picker-options="{
                  start: '00:00',
                  step: '00:15',
                  end: '23:23'
                }"
                placeholder="结束时间"
              />
            </el-form-item>
          </el-form-item>
          <el-button v-permisaction="['config:maxLevelReward:save']" type="primary" @click="onSubmit()">保存</el-button>
        </el-form>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getCommonCfg, updateCommonCfg } from '@/api/config/common-cfg'
import { formatDate } from 'element-ui'

export default {
  name: 'RobotConfig',
  data() {
    return {
      formData:
        {
          'newUserMin': 0,
          'newUserMax': 0,
          'upgradeMin': 0,
          'upgradeMax': 0,
          'maxAddFriendCount': 0,
          'addSpin': 0,
          'spins': [
            { 'min': 0, 'max': 0, 'spin': 0, 'bet': 0 }
          ],
          'giftStart': 0,
          'giftEnd': 0
        }
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    onSubmit() {
      for (const k in this.formData.spins) {
        const spin = this.formData.spins[k]
        if (spin.min > spin.max) {
          this.msgError('体力上限-等级范围最小值不能大于最大值')
          return
        }
      }

      if (this.formData.newUserMin > this.formData.newUserMax) {
        this.msgError('新手引导最小值不能大于最大值')
        return
      }

      if (this.formData.upgradeMin > this.formData.upgradeMax) {
        this.msgError('升级延时最小值不能大于最大值')
        return
      }

      if (this.formData.maxAddFriendCount <= 0) {
        this.msgError('添加好友数量不能小于0')
        return
      }

      const giftStart = this.timeToTimestamp(this.formData.giftStart)
      const giftEnd = this.timeToTimestamp(this.formData.giftEnd)
      console.log(giftStart, giftEnd)
      if (giftStart > giftEnd) {
        this.msgError('礼物互赠-开始时间不能大于结束时间')
        return
      }

      const data = JSON.stringify(this.formData)
      updateCommonCfg({ name: 'robotConfig', data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getCommonCfg({ name: 'robotConfig' }).then(res => {
        if (res.code === 200) {
          this.formData = res.data
        } else {
          this.msgError(res.msg)
        }
      })
    },
    add() {
      this.formData.props.push({ 'propsId': 3, 'skin': 0, 'num': 1 })
    },
    addSpin() {
      this.formData.spins.push({ 'min': 0, 'max': 0, 'spin': 0 })
    },
    delSpin(index) {
      this.formData.spins = this.formData.spins.filter((res, inx) => {
        return inx !== index
      })
    },
    timeToTimestamp(timeStr) {
      console.log('timeToTimestamp', timeStr)
      const [hours, minutes] = timeStr.split(':')
      const date = new Date()
      date.setHours(parseInt(hours, 10))
      date.setMinutes(parseInt(minutes, 10))
      return date.getTime()
    }
  }
}
</script>

<style scoped>
</style>
